const STORAGE_KEY = 'ea_blog_conversion_source'

/**
 * Last-touch blog attribution for the current browser tab (sessionStorage).
 * Used to enrich dataLayer events when a visitor converts after reading a blog post.
 */
export const recordBlogPageView = ({ slug, title, uri, id }) => {
	if (typeof window === 'undefined' || !slug) return
	try {
		sessionStorage.setItem(
			STORAGE_KEY,
			JSON.stringify({
				blog_post_slug: slug,
				blog_post_title: title || null,
				blog_post_path: uri || null,
				blog_post_id: id || null
			})
		)
	} catch (e) {
		// ignore quota / private mode
	}
}

/**
 * Merge query params into stored attribution when landing on the offerte flow.
 * Supports opening the form in a new tab where sessionStorage from the blog tab is absent.
 * Params: blog_source (slug), optional blog_title.
 */
export const applyBlogAttributionFromSearch = location => {
	if (typeof window === 'undefined' || !location?.search) return
	const params = new URLSearchParams(location.search)
	const blogSource = params.get('blog_source')
	if (!blogSource) return

	let decodedTitle = null
	const blogTitle = params.get('blog_title')
	if (blogTitle) {
		try {
			decodedTitle = decodeURIComponent(blogTitle)
		} catch (e) {
			decodedTitle = blogTitle
		}
	}

	try {
		let merged = {
			blog_post_slug: blogSource,
			blog_post_title: decodedTitle,
			blog_post_path: null,
			blog_post_id: null
		}
		const existing = sessionStorage.getItem(STORAGE_KEY)
		if (existing) {
			const prev = JSON.parse(existing)
			merged = {
				...prev,
				blog_post_slug: blogSource,
				blog_post_title: decodedTitle || prev.blog_post_title
			}
		}
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(merged))
	} catch (e) {
		// ignore
	}
}

export const isOfferteFlowPath = pathname => {
	if (!pathname) return false
	const normalized = pathname.replace(/\/$/, '')
	return normalized.endsWith('offerte-aanvragen')
}

/** Flat object for spreading into pushLocationEvent(..., { extras }) */
export const getBlogAttributionExtras = () => {
	if (typeof window === 'undefined') return {}
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY)
		if (!raw) return {}
		const data = JSON.parse(raw)
		const slug = data.blog_post_slug || null
		if (!slug) return {}
		return {
			blog_post_slug: slug,
			blog_post_title: data.blog_post_title || null,
			blog_post_path: data.blog_post_path || null,
			blog_post_id: data.blog_post_id || null
		}
	} catch (e) {
		return {}
	}
}
